import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const staleTime = 1000 * 60 * 24;
const authorityUrl = '/ajax/v2/backlinks/authority';

const getBacklinks = (type) => useQuery({
  queryKey: ['backlinks', {type}],
  queryFn: async () => {
    const {data} = await axios.get(
      type.value === 'authority' ? authorityUrl : `/ajax/v2/backlinks/filter/${type.value}`
    );
    return data.data;
  },
  staleTime,
});


export {
  getBacklinks,
};
